import { cva } from '@/styled-system/css';

export const popoverBackdropRecipe = cva({
  variants: {
    modal: {
      true: {
        display: 'grid',
        placeItems: 'center',
        zIndex: 'popover',
        animation: 'fade 0.2s ease-out',
        blockSize: 'auto',
        maxBlockSize: 'none',
        inlineSize: 'auto',
        maxInlineSize: 'none',
        paddingBlock: 'Popover.Backdrop.padding.default.vert',
        paddingInline: 'Popover.Backdrop.padding.default.horz',

        _before: {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundColor: 'Popover.Backdrop.bg',
          opacity: 'Popover.Backdrop',
          zIndex: 1,
          isolation: 'isolate',
        },
      },
      false: {},
    },
  },
});
